module.exports = __webpack_public_path__ + "img/task-manager-1.e6f3e3b1.png";